<template>
  <div class="Course" :style="isContent ? { gap: '120px' } : { gap: '0px' }">
    <ShortNavbar
      ref="snRef"
      :class="['Navbar', { scrolled: isScrolled }]"
      :SendRequestBusiness="
        () => {
          showRegistrationModal = true;
        }
      "
    />

    <div ref="mainRef" class="Main">
      <div class="hero-bg-container">
        <div class="hero-bg-img" />
      </div>
      <div class="Container MainContain">
        <div 
          class="Back" 
          @click="back()"
        >
          <img src="./../../assets/img/ReDesign/interface_icons/arrow_back.svg" alt=""/>
        </div>

        <div v-if="course.errorMsg" class="CourseCard" style="margin-bottom: 80px">
          <div class="CompanyInfo">
            <div class="BlockTitle">
              <span class="Title CompanyName">
                {{ $t(course.errorMsg) }}
              </span>
            </div>
          </div>
        </div>

        <div v-if="course.data" class="CourseCard">
          <div class="CompanyInfo">
            <div class="BlockRectangles">
              <span 
                v-if="course.data?.forWhom" 
                class="Rectangle" 
                style="color: #FFFFFF; background-color: #FD6161;"
              >
                {{ $t("pages.catalog_course.company_info.start") }}
                {{ normalDate(course.data?.dateStart) }}
              </span>
              <span v-if="course.data?.forWhom" class="Rectangle">
                {{ course.data?.forWhom }}
              </span>
              <span v-if="course.data?.trialSession" class="Rectangle">
                {{ $t("pages.catalog.questionnaires.trial_session") }}
              </span>
            </div>
            <div class="BlockTitle">
              <span class="Title CompanyName">
                {{ course.data?.name }}
              </span>
              <span class="SubTitle">
                {{ course.data?.n_project?.name }}
              </span>
            </div>
            <div v-if="course.data?.description" class="BlockDescriptions">
              <span class="Description">
                {{ course.data?.description }}
              </span>
            </div>
            <div class="BlockShortInfo">
              <span v-if="course.data?.courseDuration" class="Description">
                {{ monthDeclension(course.data?.courseDuration) }}
              </span>
              <span v-if="course.data?.trainFormat" class="Description">
                {{ $t(course.data?.trainFormat) }}
              </span>
              <span v-if="course.data?.lang" class="Description">
                {{ langName(course.data?.lang) }}
              </span>
            </div>
            <div class="BlockPrice">
              <span v-if="course.data?.price" class="Price">
                {{ formatNumber(course.data?.price) }}
                {{ $t("pages.catalog.questionnaires.sum") }}
              </span>
              <div class="Enabled">
                <span v-if="course.data?.homework" class="MarkText">
                  {{ $t("pages.catalog.questionnaires.homework") }}
                </span>
                <span v-if="course.data?.finalExam" class="MarkText">
                  {{ $t("pages.catalog.questionnaires.final_exam") }}
                </span>
              </div>
            </div>
          </div>
          <div class="FormRequest">
            <DefaultModal
              :key="requestForm.key"
              :class="{
                FormModal: requestForm.modalSelect !== 2,
                OpenModal: requestForm.modalSelect === 2
              }"
              :rmtitle="$t('components.default_modal[0].title')"
              :rmdesc="$t('components.default_modal[0].desc')"
              :handleModalClose="handleCloseModal"
            >
              <template v-slot:FormBody>
                <DefaultInput
                  v-model="requestForm.data.fio"
                  @update:modelStatus="requestForm.validate.fio = $event"
                  :placeholder="$t('components.default_modal[0].name_surname')"
                  :isNull="false"
                  type="fio"
                />
                <DefaultInput
                  v-model="requestForm.data.phone"
                  @update:modelPhoneFormat="requestForm.data.phoneFormat = $event"
                  @update:modelStatus="requestForm.validate.phone = $event"
                  :label="$t('components.default_modal[0].phone')"
                  type="phone"
                  :isNull="false"
                />
                <DefaultTextarea
                  v-model="requestForm.data.comment"
                  @update:modelStatus="requestForm.validate.comment = $event"
                  :placeholder="$t('components.default_modal[0].comment')"
                  :maxHeight=95
                />
              </template>
              <template v-slot:ButtonsSection>
                <div class="data-policy">
                  <CustomSelect
                    v-model="requestForm.data.dataPolicy"
                    :options="requestForm.data.dataPolicyOpt"
                    style="width: fit-content"
                    type="multiselect"
                    typeSelect="checkboxList"
                  />
                  <span class="text">
                    {{ $t("components.default_modal[2].condition_agreement_1") }}
                    <a class="link" :href="$t('links.data_policy')" download
                      >{{ $t("components.default_modal[2].condition_agreement_2") }}</a
                    >
                  </span>
                </div>

                <span
                  style="height: 48px; font-size: 16px"
                  class="btn-router-link"
                  :class="{
                    'btn-n-yellow': validateForm,
                    'btn-n-yellow-disabled': !validateForm,
                  }"
                  @click.native="sendRequest"
                >
                  {{ $t("components.default_modal[0].button") }}
                </span>
              </template>
            </DefaultModal>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isContent" class="Container">
      <div v-if="course.data?.course_teachers?.length > 0" class="TeachingStaff">
        <span class="Title">
          {{ $t("pages.catalog_course.teaching_staff.title") }}
        </span>
        <div class="BlockTeacherCards">
          <div
            v-for="(teacher, index) in courseTeachersByOrder"
            :key="teacher.id"
          >
            <div class="Card">
              <div 
                class="IconTeacher"
                :style="backgroundImgStyle(teacher.avatar)"
              ></div>
              <div class="TeacherInfo">
                <span class="FullName">{{ teacher.name }}</span>
                <span v-if="true" class="Description" style="font-size: 16px;" v-html="formatDescription(teacher.desc)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="course.data?.job_modules?.length > 0" class="CourseProgram">
        <span class="Title">
          {{ $t("pages.catalog_course.course_program.title") }}
        </span>
        <div class="PanelCP">
          <span class="NameCourse">
            {{ course.data?.name }}
          </span>
          <button 
            class="btn-n-yellow ButtonSubReq"
            @click="handleOpenModal(2)" 
          >
            {{ $t("pages.catalog_course.course_program.panel.button_sub_req") }}
          </button>
        </div>
        <div class="BlockDetailsCP">
          <div
            v-for="(module, index) in courseModulesByOrder"
            :key="module.id"
          >
            <CustomDetails>
              <template v-slot:HeadContent>
                {{ module.name }}
              </template>
              <template class="test" v-slot:BodyContent>
                <div v-html="module.desc"></div>
              </template>
            </CustomDetails>
          </div>
        </div>
      </div>
      <div 
        v-if="course.data?.n_project?.yandex_map_link" 
        class="Map" 
        style="flex-direction: column;"
      >
        <a :href="course.data?.n_project?.yandex_map_link" class="Title">
          {{ addressFormat(course.data?.n_project?.address) }}
        </a>
        <iframe 
          :src="transfromYandexMapLink(course.data?.n_project?.yandex_map_link)" 
          width="100%" 
          height="400" 
          frameborder="0"
          style="border-radius: 16px;"
          allowfullscreen="true">
        </iframe>
      </div>
    </div>

    <GeneralFooter />

    <DefaultModal
      class="FormSuccessModal"
      v-show="requestForm.modalSelect === 1"
      :rmtitle="$t('components.default_modal[1].title')"
      :rmdesc="$t('components.default_modal[1].desc')"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:ButtonsSection>
        <span
          style="height: 48px; font-size: 16px"
          class="btn-n-yellow btn-router-link"
          @click.native="handleCloseModal"
        >
          {{ $t("components.default_modal[5].button") }}
        </span>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import ShortNavbar from "@/components/ShortNavbar";
import GeneralFooter from "@/components/Footer";
import DefaultModal from "@/components/DefaultModal";
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";
import CustomDetails from "@/components/OctaUI/CustomDetails";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";

import { transformUrl } from "@/utils/transformUrl.js";
import { getJobByIDPublic } from "@/api/job.js";
import { RequestCreate } from "@/api/request.js";
import { ElNotification } from "element-plus";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    ShortNavbar,
    GeneralFooter,
    DefaultModal,
    DefaultInput,
    DefaultTextarea,
    CustomDetails,
    CustomSelect
  },
  data() {
    return {
      // Информация о курсе
      course: {
        data: null,
        errorMsg: null
      },

      // Форма заявки
      requestForm: {
        key: 0,
        modalSelect: null,
        data: {
          fio: null,
          phone: null,
          phoneFormat: null,
          comment: '',
          dataPolicy: [],
          dataPolicyOpt: [{
            value: "dataPolicy",
            name: "",
          }],
        },
        validate: {
          fio: false,
          phone: false,
          comment: false
        }
      },

      // El Сообщения
      msg: {
        title: {
          serverError: this.$t("components.el_notification[1].message"),
        },
        form: {
          success: {
            title: this.$t("components.el_notification[0].title"),
            type: "success",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
          error: {
            title: this.$t("components.el_notification[1].title"),
            type: "error",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
        },
      },

      // Айди языков
      langList: [
        { id: 1, lang: "Русский" },
        { id: 2, lang: "English" }, // На всякий случай оставлен
        { id: 3, lang: "Oʻzbekcha" },
      ],

      isScrolled: false,
    };
  },
  mounted() {
    this.getCourse();
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    // Сортируем модули по Order
    courseModulesByOrder() {
      return this.course.data.job_modules.sort((a, b) => a.order - b.order);
    },
    // Сортируем учителей по Order
    courseTeachersByOrder() {
      return this.course.data.course_teachers.sort((a, b) => a.order - b.order);
    },

    validateForm() {
      return (
        this.requestForm.validate.fio &&
        this.requestForm.validate.phone &&
        this.requestForm.validate.comment &&
        this.requestForm.data.dataPolicy.length > 0
      );
    },

    // Проверяем, есть ли хоть какой-нибудь контент у курса
    isContent() {
      return (
        this.course.data?.course_teachers?.length > 0 ||
        this.course.data?.job_modules?.length > 0 ||
        this.course.data?.n_project?.yandex_map_link
      );
    }
  },
  methods: {
    async getCourse() {
      try {
        // Если id передан в route и не пустой 
        if (this.$route.query?.id != null && this.$route.query?.id != "") {
          this.course.data = (await getJobByIDPublic(this.$route.query.id)).data;
        } 
      } catch (e) {
        console.log(e);
        // При ошибке делаем редирект на страницу каталога
        this.$router.push('/catalog/');
      }
    },

    async sendRequest() {
      let fullNumber = this.requestForm.data.phoneFormat + this.requestForm.data.phone.replace(/\D/g, "");

      try {
        let reqResponse = await RequestCreate({
          surname_name: this.requestForm.data.fio,
          phone: fullNumber.replaceAll(" ", ""),
          email: "",
          additional: this.requestForm.data.comment,
          course_id: this.course.data?.id,
          education_id: this.course.data?.n_project?.company_id,
          type_code: "ec_catalog_request",
          data_policy: this.requestForm.data.dataPolicy.length > 0 ? true : false
        });

        if (reqResponse.status != 200) {
          throw new Error("Ошибка");
        }

        this.handleOpenModal(1);
      } catch (e) {
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }

      this.handleOpenModal(1);
    },

    // Из id языка получаем его название
    langName(id) {
      return this.langList.find((lang) => lang.id === id).lang;
    },

    handleScroll() {
      // Находим границу перехода навбара с main
      const contentHeight = this.$refs.mainRef.scrollHeight - this.$refs.snRef.$el.offsetHeight;
      // Если мы перешли границу - указываем это в переменной isScrolled
      this.isScrolled = window.scrollY > contentHeight;
    },

    normalDate(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();

      return `${day}.${month}.${year}`;
    },

    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    formatDescription(text) {
      if (!text) return '';
      // Заменяем переносы строк на <br> и экранируем HTML
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br>');
    },

    back() {
      // Удаляем event при переходе
      window.removeEventListener("scroll", this.handleScroll);

      // Проверка есть ли история для возврата
      if (window.history.length > 1) {
        // Возвращаемся на один шаг назад по ссылке с сохранением состояния
        this.$router.go(-1);
      } else {
        // Иначе возвращаем на каталог
        this.$router.push('/catalog'); 
      }
    },

    // Склонение месяцев
    monthDeclension(months) {
      let monthsText = [
        this.$t("pages.catalog.questionnaires.months[0]"),
        this.$t("pages.catalog.questionnaires.months[1]"),
        this.$t("pages.catalog.questionnaires.months[2]"),
      ];

      // На основе количества месяцев выбираем склонение
      // Если окончание 0, 5-9 или число входит в 11-14 - "месяцев"
      if (
        months % 10 >= 5 ||
        months % 10 === 0 ||
        [11, 12, 13, 14].find((item) => item === months)
      )
        return months + " " + monthsText[2];
      // Если окончание 2-4 - "месяца"
      if (months % 10 >= 2) return months + " " + monthsText[1];

      // Иначе если окончание 1 - "месяц"
      return months + " " + monthsText[0];
    },

    handleOpenModal(number) {
      this.requestForm.data.fio = null;
      this.requestForm.data.phone = null;
      this.requestForm.data.comment = '';
      this.requestForm.data.dataPolicy = [];

      this.requestForm.key++;
      this.requestForm.modalSelect = number;
    },

    handleCloseModal() {
      this.requestForm.data.fio = null;
      this.requestForm.data.phone = null;
      this.requestForm.data.comment = '';
      this.requestForm.data.dataPolicy = [];

      this.requestForm.key++;
      this.requestForm.modalSelect = null;
    },

    backgroundImgStyle(img_url) {
      if (img_url) {
        return {
          background: `url('${this.transformLink(img_url)}')`,
          backgroundSize: 'contain' // Подстраивает картинку под размер
        };
      }
      return {};
    },

    transformLink(url) {
      return transformUrl(url);
    },

    transfromYandexMapLink(url) {
      // Получаем индекс координат на карте в url
      const mapsIndex = url.indexOf('maps/');

      // Если координаты указаны
      if (mapsIndex !== -1) {
        // Получаем координаты
        const mapPosition = url.substring(mapsIndex + 'maps/'.length);

        // Возвращаем url виджета с указанными координатами
        return `https://yandex.ru/map-widget/v1/${mapPosition}`;
      } else {

        // Возвращаем url виджета без координат(в данном случае покажет текущее местоположение)
        return `https://yandex.ru/map-widget/v1/`;
      }
    },

    // Формартирую адрес в вид "[0], [1], [2], [3], [4], [5]"
    addressFormat(address) {
      if (!address) return "";

      const addressSplit = address.split("{%;%}");
      let result = "";

      for (const element of addressSplit) {
        if (!result) result += element;
        else if (element) result += ", " + element;
      }

      return result;
    },
  },
};
</script>

<style scoped>
.Course {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  margin-left: auto;
  margin-right: auto;

  flex-direction: column;
  justify-content: flex-start;

  font-family: "Involve";

  gap: 120px;
  overflow: hidden;
  background: white;
}

.Navbar.scrolled {
  background-color: #fff; /* изменённый цвет */
}
.Navbar {
  position: fixed;
  padding: 15px 0%;
  top: 0;

  background-color: #f9d773;
}

.Back {
  position: relative;
  display: flex;

  width: 48px;
  height: 48px;

  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  background: #FFFFFF;

  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;
  transition: 0.3s;
}
.Back:hover {
  transition: 0.3s;
  background: #F8F8F8;
}

.Container {
  position: relative;
  display: flex;

  width: 100%;
  max-width: 1168px;
  height: fit-content;

  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;

  flex-direction: column;
  justify-content: flex-start;

  font-family: "Involve";

  gap: 120px;
}
.Container.MainContain { 
  margin-top: 80px;
  gap: 40px;
}
.Container .CourseCard {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  gap: 32px; 
  justify-content: space-between; 
}
.Title {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 700;
  font-size: 40px;
  line-height: 120%;
  align-items: center;

  color: #1A1A1A;

  word-break: break-word;
}
.SubTitle {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  align-items: center;

  color: #666666;

  word-break: break-word;
}
.Description {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  align-items: center;

  color: #666666;

  word-break: break-word;
}

.FormModal {
  position: relative;
  display: flex;

  height: fit-content;
  width: 100%;

  background-color: transparent;
  z-index: 2;
}
.FormModal:deep(.RMContainer) {
  max-width: 100%;
}
.FormModal:deep(.CloseModal) {
  display: none;
}

.hero-bg-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.hero-bg-img {
  position: relative;
  display: block;

  margin-left: auto;

  width: auto;
  height: 100%;

  aspect-ratio: 1 / 0.4166;

  background: url("./../../assets/img/ReDesign/pages/new_land/Фон.png");
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;

  filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(10%)
    hue-rotate(58deg) brightness(104%) contrast(104%);
}

.Main {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: space-between;
  gap: 40px;

  background-color: #f9d773;
  min-height: 880px;
  
}

.Main .CompanyInfo {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  gap: 24px;
}

.CompanyInfo .BlockRectangles {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  gap: 8px;

  flex-wrap: wrap;
}
.BlockRectangles .Rectangle {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  justify-content: center;
  align-items: center;
  padding: 4px 12px;

  background: #F3F3F3;
  border-radius: 4px;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;

  color: #666666;
  word-break: break-word;
}

.CompanyInfo .BlockTitle {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  gap: 16px;
}

.CompanyInfo .BlockDescriptions {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;
}

.CompanyInfo .BlockShortInfo {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  gap: 16px;
}

.CompanyInfo .BlockPrice {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  gap: 4px;
}
.BlockPrice .Price {
  position: relative;
  display: inline-flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;

  color: #FD6161;
}
.BlockPrice .Enabled {
  position: relative;
  display: inline-flex;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  gap: 8px;
}
.Enabled .MarkText {
  position: relative;
  display: inline-flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;

  color: #666666;

  padding-left: 13px;
  background-image: url('./../../assets/img/ReDesign/pages/catalog/check-mark.svg');
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: left center;
}

.Main .FormRequest {
  position: relative;
  display: flex;

  min-width: 400px;
  width: 400px;
  height: fit-content;

  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.04);
}

.TeachingStaff {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 40px;
}
.TeachingStaff .BlockTeacherCards {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 24px;
}
.BlockTeacherCards .Card {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  align-items: center;

  flex-direction: row;
  gap: 16px;
}
.Card .IconTeacher {
  position: relative;
  display: flex;

  width: 128px;
  height: 128px;

  border-radius: 16px;

  background-color: #fd616133;
  text-decoration: none;

  overflow: hidden;

  flex-shrink: 0;

  background: url('./../../assets/img/ReDesign/interface_icons/default_teacher_icon.png');
  background-size: contain;
}
.Card .TeacherInfo {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  align-items: flex-start;

  flex-direction: column;
  gap: 16px;
}
.TeacherInfo .FullName {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  align-items: center;

  color: #1A1A1A;

  word-break: break-word;
}
 
.CourseProgram {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 24px;
}

.CourseProgram .PanelCP {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  margin-top: 16px;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;

  align-items: center;
}
.PanelCP .NameCourse {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  align-items: center;

  color: #1A1A1A;
  word-break: break-word;
}
.PanelCP .ButtonSubReq {
  min-width: fit-content;
  width: fit-content; 
  height: 48px; 

  padding: 12px 20px; 
  font-size: 16px;
}

.CourseProgram .BlockDetailsCP {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 10px;
}
.BlockDetailsCP ul {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;

  margin: 0;
  padding-left: 28px;
}

.Map {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 40px;
}

.DescText {
  display: inline-block;
  position: relative;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  position: relative;
  display: inline;
  width: fit-content;
  height: fit-content;
  max-width: 100%;
}

.BackText {
  display: inline;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
  text-decoration: underline;

  white-space: normal; 
  word-wrap: break-word;
}

.data-policy {
  display: flex;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.data-policy > .text {
  display: inline-block;
  position: relative;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;

  color: #666666;
}
.data-policy > .text > .link {
  display: inline;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
  text-decoration: underline;

  white-space: normal; 
  word-wrap: break-word;
}
</style>

<style scoped>
@media (min-width: 992px) {
  .Navbar {
    position: absolute;
    padding: 15px 0%;
    top: 0;

    background-color: #f9d773 !important;
  }
}

@media (max-width: 900px) {
  .Container .CourseCard {
    flex-direction: column;
    justify-content: center;
    gap: 24px;
  }
  .Main {
    min-height: 240px;
  }
  .Main .FormRequest {
    min-width: 0px;
    width: 100%;
    margin-bottom: 24px;
  }
  .FormModal:deep(.RMContainer) {
    width: 100%;
  }
  .FormModal:deep(.RMView) {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .BlockTeacherCards .Card {
    flex-direction: column;
    align-items: flex-start;
  }
  .CourseProgram .PanelCP {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-top: 11px;
  }
}

@media (max-width: 480px) {
  .Title {
    font-weight: 600;
    font-size: 32px;
    line-height: 130%;
  }
  .PanelCP .NameCourse {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
  }
  .CompanyName {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
  }
  .SubTitle {
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
  }
  .Description {
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
  }
  .BlockPrice .Price {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
  }
  .Enabled .MarkText {
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
  }
  .FormModal:deep(.RMTitle) {
    font-weight: 500;
    font-size: 20px;
    line-height: 130%;
  }
  .FormModal:deep(.RMDesc) {
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
  }
}
</style>